const classPrefix = 'modal-pay';
const dataPrefix  = 'data-modal-pay';
import axios from 'axios';
export function modalPay($container, exerciseId = 0) {
    const $template = document.querySelector('[data-modal-pay-template]');
    if (!$template) return;

    const $modal = document.importNode($template.content, true);
    $container.appendChild($modal);

    const $root  = $container.lastElementChild;
    const $btn   = $root.querySelector('[data-modal-pay-btn]');
    const $items = Array.from($root.querySelectorAll('[data-select-type]'));

    if (!$btn || !$items.length) return;

    const telegramId = $root.dataset.telegramId;
    const username   = $root.dataset.username || '';

    let selectedType = null;

    function selectItem($item) {
        $items.forEach(i => {
            i.dataset.select = 'false';
            i.classList.remove('modal-pay__select-item--selected');
        });
        $item.dataset.select = 'true';
        $item.classList.add('modal-pay__select-item--selected');
        selectedType = $item.dataset.selectType;
    }

    $items.forEach($item => {
        $item.addEventListener('click', () => selectItem($item));
    });

    const initially = $items.find(i => i.dataset.select === 'true') || $items[0];
    selectItem(initially);

    $btn.addEventListener('click', async (e) => {
        e.preventDefault();
        if (!selectedType) return;

        // Подготовка данных
        const payload = {
            telegram_id: telegramId,
            username,
        };
        if (selectedType === 'personal') {
            payload.video_id = exerciseId;
        }

        try {
            const response = await axios.post(
                `/api/cloudpayments/route-payment/${selectedType}`,
                payload
            );
            const json = response.data;

            const payUrl = json.data?.Model?.Url;
            if (!payUrl) {
                console.error('Нет Model.Url в ответе:', json);
                alert('Не удалось получить ссылку на оплату.');
                return;
            }

            // Редирект на страницу оплаты
            window.location.href = payUrl;

        } catch (err) {
            // Обработка ошибок
            if (err.response) {
                console.error('Ошибка API:', err.response.data);
                alert('Не удалось создать платёж: ' + (err.response.data.error || 'Попробуйте ещё раз.'));
            } else {
                console.error('Сетевая ошибка:', err);
                alert('Сетевая ошибка, проверьте соединение.');
            }
        }
    });
}
